import * as yup from 'yup';
import * as utils from './utils';
import { JourneePedagogique } from '../entities';

export const schemaJourneePedagogique = yup.object<Partial<JourneePedagogique>>({
    fk_id_calendrier: yup.number().nullable(),
    type_flottant: yup.string().nullable(),
    date: utils.toStringSchema(yup.date().nullable().transform(utils.emptyStringToNullTransform)),
    notes: yup.string().nullable(),
}) as yup.ObjectSchema<Partial<JourneePedagogique>>;